import { createClient } from 'contentful';

// Replace with your Contentful credentials
const client = createClient({
  space: 'exsbjwylaase',          // Replace with your Space ID
  accessToken: '34zeSE2qT8KjeqvpRPQksdIJUXa17tMXJNt76s71fWU' // Replace with your Access Token
});

export const fetchBlogPosts = async () => {
  try {
    const entries = await client.getEntries({
      content_type: 'blogPost', // Ensure this matches the API ID of your Content Model
      order: '-fields.publishDate' // Sort by most recent posts
    });
    return entries.items;
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    return [];
  }
};
